import React from 'react';
import { observer } from 'mobx-react';
import { Button, Tooltip } from 'antd';
import { CustomerServiceOutlined } from '@ant-design/icons';
import { Catcher } from '../';
import { AppSystem, IDivMainProps } from '../../interfaces';
import { useAppSystem, useProfileFeatureFlags, useProfileIsRight, useRouterStore } from '../../hooks';
import { tI } from '../../translate';
import Styles from './m_styles.less';

export const SupportButton: React.FC<IDivMainProps> = observer(() => {
    const routerStore = useRouterStore();
    const isRoot = useProfileIsRight('ROOT');
    const allowImpersonate = useProfileFeatureFlags().allowImpersonate;
    const allowOperatorInteractions = useProfileFeatureFlags().allowOperatorInteractions;
    const appSystem = useAppSystem();

    return (isRoot || allowImpersonate || allowOperatorInteractions) && appSystem === AppSystem.OCS ? (
        <Catcher>
            <Tooltip title={tI('Support Page')} placement="bottomRight">
                <Button
                    className={Styles.supportButton}
                    onClick={() => routerStore.goTo('SupportPage')}
                    icon={<CustomerServiceOutlined />}
                />
            </Tooltip>
        </Catcher>
    ) : null;
});
